import { createSlice } from '@reduxjs/toolkit'

export const returnSlice = createSlice({
	name: 'return',
	initialState: {
		isAnyFieldToHighlight: false,
		fieldToHighlight: {
			reclamationReasonApiKey: false,
			returnOrderItemConditionApiKey: false,
		},
	},
	reducers: {
		startCheckIsAnyFieldToHighlight: (state, { payload }) => {
			state.isAnyFieldToHighlight = true
		},
		setFieldToHighlight: (state, { payload }) => {
			let fields = {}
			payload.forEach((name) => {
				fields[name] = true
			})
			state.fieldToHighlight = {
				...state.fieldToHighlight,
				...fields,
			}
		},
		clearFieldToHighlight: (state, { payload }) => {
			state.isAnyFieldToHighlight = false
			state.fieldToHighlight = {
				...state.fieldToHighlight,
				[payload]: false,
			}
		},
		setFieldToHighlightToDefault: (state, { payload }) => {
			state.isAnyFieldToHighlight = false
			state.fieldToHighlight = {
				reclamationReasonApiKey: false,
				returnOrderItemConditionApiKey: false,
			}
		},
	},
})

export const {
	startCheckIsAnyFieldToHighlight,
	setFieldToHighlightToDefault,
	setFieldToHighlight,
	clearFieldToHighlight,
} = returnSlice.actions
export const { reducer } = returnSlice
